import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useTable } from '@app/components/table';
import { ReviewList } from './review-list';
import { AddReview } from './add-review';
import { useDialog, useRequestState, useSearch } from '@app/hooks';
import { getReviews } from '../slice';
import { selectReviewState } from '../selecter';
import { useAuthRole } from '@app/utils';

export const ReviewListPage = () => {
  const tableProps = useTable();
  const addReviewDialog = useDialog();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getReviews());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectReviewState,
    errorShown: true,
  });

  const { isSuperAdmin } = useAuthRole();
  const [selectedReviewRole, setSelectedReviewRole] = useState(Strings.project.teamLeader);

  const handleDropDownOption = (option: any) => {
    setSelectedReviewRole(option);
  };

  const isTLSelected = selectedReviewRole === Strings.project.teamLeader;
  const filteredData = data?.filter((review: any) =>
    isTLSelected ? review.usersReviewTo?.roleId === 2 : review.usersReviewTo?.roleId !== 2
  );
  const searchProps = useSearch({
    data: isSuperAdmin ? filteredData : data,
    fields: ['reviewTo', 'reviewFrom', 'name', 'id'],
  });

  return (
    <>
      <Header
        title={Strings.reviews.reviews}
        helperText={''}
        actionButtonTitle={Strings.reviews.addReview}
        onClickActionButton={addReviewDialog.show}
        dropDownOptions={
          isSuperAdmin ? [Strings.project.teamLeader, Strings.reviews.teamMember] : undefined
        }
        dropDownSelect={isSuperAdmin ? selectedReviewRole : undefined}
        dropDownLabel={Strings.reviews.reviewOf}
        onClickDropDownOption={handleDropDownOption}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
      />
      <ReviewList
        tableProps={tableProps}
        rows={searchProps.filteredRows}
        loading={loading}
        isTLSelected={isTLSelected}
      />
      {addReviewDialog.visible && (
        <AddReview open onClose={addReviewDialog.hide} isTLSelected={isTLSelected} />
      )}
    </>
  );
};
